import axiosInstance from "../Interceptors/ResponseInterceptor";

export function getAllPartners() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/partner-master/getPartners`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllDomain:", error);
      reject(error);
    }
  });
}

export function getAllPremiums() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/premiumness-master/getPremiums`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllDomain:", error);
      reject(error);
    }
  });
}

export function getAllProcesses() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/site-process/getSiteProcess`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in get in All Site Processes", error);
      reject(error);
    }
  });
}
